import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.some";
import "core-js/modules/es.object.keys";
import _toConsumableArray from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { cloneDeep } from 'lodash';
import CenterHome from './comp/center-home.vue';
export default {
  meta: {
    title: '实时概况',
    auth: true,
    authorityValue: "store-statistics-management"
  },
  name: 'realTime',
  components: {
    CenterHome: CenterHome
  },
  data: function data() {
    return {
      newsList: [{
        tit: '访客数',
        centent: 2
      }, {
        tit: '浏览量',
        centent: 2
      }, {
        tit: '成交客户数',
        centent: 2
      }, {
        tit: '成交单量',
        centent: 2
      }, {
        tit: '成交商品件数',
        centent: 2
      }, {
        tit: '成交金额',
        centent: 2
      }],
      chartData: {
        columns: [],
        rows: []
      },
      value1: '',
      radioForm: {
        visitors: true,
        orderAmount: true,
        browses: true,
        orderGoods: true,
        orders: true,
        orderConsumers: true
      }
    };
  },
  watch: {
    radioForm: {
      handler: function handler(e) {
        this.dataBind();
      },
      deep: true
    }
  },
  methods: {
    dataBind: function dataBind(item) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$api.dataTodayTrends(item);

              case 2:
                data = _context.sent;
                _this.chartData.columns = ['序号'];
                _this.chartData.rows = _this.setObj(data);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    setObj: function setObj(obj) {
      var _this2 = this;

      var isTrue = function isTrue(type) {
        return Object.keys(_this2.radioForm).some(function (key) {
          return type == key && _this2.radioForm[key];
        });
      };

      var columns = ['访客数', '成交金额', '浏览量', '成交商品数', '订单数', '成交客户数'];
      var columnsKey = ['visitors', 'orderAmount', 'browses', 'orderGoods', 'orders', 'orderConsumers'];
      var data = obj.map(function (v, i) {
        isTrue(columnsKey[i]) && _this2.chartData.columns.push(columns[i]);
        var obj = {
          序号: v.hour,
          访客数: v.visitors,
          成交金额: v.orderAmount,
          浏览量: v.browses,
          成交商品数: v.orderGoods,
          订单数: v.orders,
          成交客户数: v.orderConsumers
        };
        return obj;
      });
      return cloneDeep(data);
    }
  },
  computed: {
    orderPlatform: function orderPlatform() {
      var item = {
        label: '全部渠道',
        value: ''
      };
      return [item].concat(_toConsumableArray(this.dict.orderPlatform));
    }
  },
  mounted: function mounted() {
    this.dataBind();
  }
};